<template>
  <div class="mini_cart_wrapper">
    <a href="javascript:void(0)" class="me-3">
      <img class="cart_image" src="/img/newsIcons/CARRINHO.webp">
      <span class='badge badge-warning position-absolute' id='lblCartCount'>{{ total_items() }}</span>
      <!--<span>{{ total_items() }} {{ br_price(cart?.total_price) }}</span>
      <i class="fas fa-shopping-cart"></i>-->
    </a>
    <!--mini cart-->
    <div class="mini_cart mini_cart_seven">
      <div class="cart_item" v-for="item in cart?.cart_item" :key="item.id">
        <!-- <div class="cart_img">
          <a href="#"
            ><img src="/img/teste/minicard1.jpeg" alt="" title="Remover"
          /></a>
        </div> -->
        <div class="cart_info">
          <a href="#"><span v-html="item?.quantity+'x '+(item?.product?.name || item?.ad?.name+' <small>(classificado)</small>')"></span> 
            <small><em class="muted">{{ item?.store?.name }} - {{ item?.product_store?.condition?.short_name || '' }} - {{ item?.product_store?.origin?.name || 'Brasil' }}</em></small>
            <span class="price_cart">{{ br_price( (item?.price * item?.quantity) ) }}</span>
          </a>
          
        </div>
        <div class="cart_remove">
          <a href="#" @click="remove_from_cart(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
        </div>
      </div>
      
      <div class="mini_cart_table">
        <div class="cart_total">
          <span>Subtotal:</span>
          <span class="price">{{ br_price(cart?.total_price) }}</span>
        </div>
      </div>

      <div class="mini_cart_footer">
        <div class="cart_button row">
          <div class="col-6">
            <a href="/cart" :class="{ disabled: cart.total_price === '0.00' }">Ver carrinho</a>
          </div>
          <div class="col-6">
            <a href="/checkout" :class="{ disabled: cart.total_price === '0.00' }">Finalizar Pedido</a>
          </div>
        </div>
      </div>
    </div>
    <!--mini cart end-->
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: "Olá do Vue.js!",
    };
  },
  computed: {
    cart() {
      return this.$store.state.cart.cart;
    },

  },
  methods:{
    br_price(price) {
      if(price){
        return parseFloat(price).toLocaleString("pt-br", {
          style: "currency",
          currency: "BRL",
        });
      }  
    },
    total_items(){
      var sum = 0;
      if(this.cart?.cart_item?.length){
        this.cart?.cart_item.forEach(item => {
          sum += item.quantity;
        });
      }

      return sum;
    
    },
    remove_from_cart(item){
      this.$store.dispatch("cart/destroy_cart", {id: item.id, guest: this.$store.state.user.guest});
    }  
  },
  created() {
    this.$store.dispatch("cart/get_cart", this.$store.state.user.guest);
  },
};
</script>

<style>
.disabled {
  pointer-events: none;
  opacity: 0.5;
}
.badge {
  padding-left: 9px;
  padding-right: 9px;
  -webkit-border-radius: 9px;
  -moz-border-radius: 9px;
  border-radius: 9px;
}
.cart_image {
  width: 40px;
}
.label-warning[href],
.badge-warning[href] {
  background-color: #c67605;
}
#lblCartCount {
  font-size: 12px;
  background: #ff0000;
  color: #fff;
  padding: 0 5px;
  vertical-align: top;
  margin-left: -10px; 
}
@media (min-width: 360px) and (max-width: 768px) {
  #lblCartCount {
    margin-left: -10px;
  }
  .cart_image {
    width: 20px;
    margin-left: 5px;
  }
}
</style>